import React, { PropTypes } from 'react';

const {
    PAYPAL_EMAIL
} = require('../core/constants').default;

const ProductItem = ({ product }) => (
    <div className="col-md-4 col-sm-6 col-xs-12 grid-item course">
        <div className="image">
            <img src={product.image} alt={product.title} className="img-responsive" />
        </div>
        <div className="info-block">
            <ul className="meta">
                <li>
                    <h3>{product.title}</h3>
                </li>
                <li>
                    <h4>&pound;{product.price}</h4>
                </li>
            </ul>
            <span dangerouslySetInnerHTML={{ __html: product.description }} />
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post">
                <input type="hidden" name="business" value={PAYPAL_EMAIL} />
                <input type="hidden" name="cmd" value="_xclick" />
                <input type="hidden" name="item_name" value={product.title} />
                <input type="hidden" name="amount" value={product.price} />
                <input type="hidden" name="currency_code" value="GBP" />
                <input
                    type="image" name="submit" border="0"
                    src="https://www.paypalobjects.com/webstatic/en_US/i/btn/png/btn_buynow_107x26.png"
                    alt="Buy Now" />
                <img
                    alt="" border="0" width="1" height="1"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" />
            </form>
        </div>
    </div>


);

ProductItem.propTypes = {
    product: PropTypes.object.isRequired
};

export default ProductItem;



/** WEBPACK FOOTER **
 ** ./src/components/ProductItem.js
 **/